import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ReduxApplicationState } from 'src/redux/types';
import { fetchPartnerContentClient } from 'src/services/contentstack/fetchPartnerContentClient';
import type { ContentstackPartner } from 'src/services/contentstack/types/PartnerPage.types';

export interface RequestPartnerContentOptions {
  shortcode: string;
}

export const requestPartnerContent = createAsyncThunk<
  ContentstackPartner | null,
  RequestPartnerContentOptions
>('partner/requestPartnerContent', async ({ shortcode }, { getState }) => {
  const { contentPreview } = (getState() as ReduxApplicationState).user;

  return fetchPartnerContentClient(shortcode, { preview: contentPreview === true });
});
